// extracted by mini-css-extract-plugin
export default {"wrapper":"Zm-z","response":"_m-z","error":"an-z","disabled":"bn-z","buttons":"cn-z","feedbackQuestionSection":"dn-z","yesNoWrapper":"en-z"};